import React from 'react';
import styled from 'styled-components';
import Page from './page';
import { useAPIData } from '../dal/useAPIData';
import { useParams } from 'react-router-dom';
import EmptyPage from './empty-page';
import Loading from './loading';

const Wrapper = styled.div`
  background: #fff;
`;

const KnowledgePage = () => {
  const { knowledgeId } = useParams();

  const {
    data: knowledge,
    dataFetched,
    failedFetch,
    fetchInProgress
  } = useAPIData(
    'knowledge.GET_KNOWLEDGE_DOCUMENT',
    { knowledgeId },
    { preferObject: true, log: true }
  );
  if (fetchInProgress) return <Loading />;
  if ((!knowledge && dataFetched && !fetchInProgress) || failedFetch) return <EmptyPage />;

  return (
    <Wrapper>
      <Page knowledge={knowledge} />
    </Wrapper>
  );
};

export default KnowledgePage;
